export const getIframe = (formUrl: string, title = 'DSAR Form') => {
  return `<iframe
  src="${formUrl}?bg=0"
  title="${title}"
  allow="clipboard-write;"
></iframe>`
}
